module.exports = __webpack_public_path__ + "static/media/error-type.16254b3c0179cd5dc8c98c15479b44cc.png";